export const table = {
  editFlow: 'Edytuj szablon konfiguracji',
  editFlowPackages: 'Edytuj pakiety',
  previewFlowPackages: 'Podgląd pakietów',
  copyFlow: 'Kopiuj szablon konfiguracji',
  editStages: 'Edytuj etapy',
  previewStages: 'Podlgąd etapów',
  deleteFlow: 'Usuń szablon konfiguracji',
  viewFlow: 'Podgląd szablonu konfiguracji',
  editFlowData: 'Edytuj dane szablonu konfiguracji',
  previewFlowData: 'Podgląd danych szablonu konfiguracji',
} as const
